// memory-monitor.js
// iOS向けメモリ監視ユーティリティ

/**
 * iOS向けメモリ監視を開始
 * @param {Object} store - Vuex ストア（state.isIOS を読む）
 * @param {number} [intervalMs=30000] - チェック間隔（ミリ秒）
 * @param {number} [threshold=0.85] - 警告しきい値（0-1）
 * @returns {Function} クリーンアップ関数
 */
export function startMemoryMonitor(store, intervalMs = 30000, threshold = 0.85) {
  const isIOS = !!(store && store.state && store.state.isIOS)
  if (!isIOS) return () => {}


  const checkMemory = () => {
    // performance.memory は Chrome/Edgeのみ対応
    if (performance.memory) {
      const used = performance.memory.usedJSHeapSize / 1048576 // MB
      const limit = performance.memory.jsHeapSizeLimit / 1048576 // MB
      const ratio = used / limit

      if (ratio > threshold) {
        console.warn(
          `[OH3/iOS] High memory usage: ${used.toFixed(0)}MB / ${limit.toFixed(0)}MB (${(ratio * 100).toFixed(1)}%)`
        )

        // ガベージコレクション強制（開発環境のみ）
        if (window.gc && typeof window.gc === 'function') {
          try {
            window.gc()
          } catch (_) {}
        }
      }
    } else {
      // Safari等では performance.memory が使えないため、代替手段
      // navigator.deviceMemory (実験的機能) で大まかなメモリ情報を取得
      if (navigator.deviceMemory) {
        const deviceMemoryGB = navigator.deviceMemory

        // デバイスメモリが少ない場合に警告
        if (deviceMemoryGB <= 2) {
          console.warn('[OH3/iOS] Low device memory detected. App may crash on memory-intensive operations.')
        }
      }
    }
  }

  // 初回実行
  checkMemory()

  // 定期実行
  const intervalId = setInterval(checkMemory, intervalMs)

  // クリーンアップ関数を返す
  return () => {
    clearInterval(intervalId)
  }
}

/**
 * 現在のメモリ使用状況を取得（デバッグ用）
 * @returns {Object|null} メモリ情報オブジェクト
 */
export function getMemoryInfo() {
  if (performance.memory) {
    return {
      usedMB: (performance.memory.usedJSHeapSize / 1048576).toFixed(1),
      totalMB: (performance.memory.totalJSHeapSize / 1048576).toFixed(1),
      limitMB: (performance.memory.jsHeapSizeLimit / 1048576).toFixed(1),
      ratio: ((performance.memory.usedJSHeapSize / performance.memory.jsHeapSizeLimit) * 100).toFixed(1) + '%',
    }
  }

  if (navigator.deviceMemory) {
    return {
      deviceMemoryGB: navigator.deviceMemory,
    }
  }

  return null
}
